let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kSd4I")).then(() => parcelRequire('7yvJu'));